/**
 * A chapter that holds other sections.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readArray, readBoolean, readNumber, readString } from '@/domain/json'
import { type GroupSection } from '@/domain/section'
import GroupBlock from '@/sections/group/GroupBlock.vue'
import GroupInspector from '@/sections/group/GroupInspector.vue'
import {
  DEFAULT_GROUP_ALIGN,
  DEFAULT_GROUP_COLUMNS,
  readAlign,
  readColumns,
} from '@/sections/group/layout'
import type { SectionDefinition } from '@/sections/types'

export const groupSection: SectionDefinition<'group', GroupSection> = {
  kind: 'group',
  band: 'structure',

  icon: ['M2 4.5A1 1 0 0 1 3 3.5h3l1.4 1.6H13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z'],

  create: (id, title) => ({
    id,
    kind: 'group',
    title,
    children: [],
    collapsed: false,
    showTitle: true,
    columns: DEFAULT_GROUP_COLUMNS,
    align: DEFAULT_GROUP_ALIGN,
  }),

  read: ({ id, title, stored, readChildren }) => ({
    id,
    kind: 'group',
    title,
    children: readChildren(readArray(stored, 'children')),
    collapsed: readBoolean(stored, 'collapsed'),
    showTitle: readBoolean(stored, 'showTitle', true),
    columns: readColumns(readNumber(stored, 'columns', DEFAULT_GROUP_COLUMNS)),
    align: readAlign(readString(stored, 'align')),
  }),

  block: GroupBlock,
  inspector: GroupInspector,
  holdsChildren: true,
}
